import { Component, OnInit } from '@angular/core';
import { ToastersService } from '../../../global/services/toasters.service';
import { Toast } from '../../../global/interfaces/toast';
import { Router } from '@angular/router';
import { NotificationService } from '../../../global/services/notification.service';

@Component({
  selector: 'app-toasters',
  templateUrl: './toasters.component.html',
  styleUrls: ['./toasters.component.less'],
})
export class ToastersComponent implements OnInit {
  toasts: Toast[] = [];
  toastDuration = 10000;
  maxToasts = 4;
  statusToastCount = 0;

  constructor(
    private toasterService: ToastersService,
    private router: Router,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {
    this.toasterService.newToast.subscribe((toast) => this.addToast(toast));
    this.toasterService.removeByTimestampSubject.subscribe(this.removeToastByStamp.bind(this));
  }

  addToast(toast: Toast) {
    if (!toast) return;
    if (toast.isStatusToast) this.statusToastCount++;
    if (this.toasts.length >= this.maxToasts + this.statusToastCount) {
      this.toasts.shift();
    }
    this.toasts.splice(this.statusToastCount, 0, toast);
    this.startToastRemoveCountdown(toast);
  }

  startToastRemoveCountdown(toast: Toast) {
    if (toast.isStatusToast) return;
    setTimeout(() => {
      this.removeToastByStamp(toast.timestamp);
    }, this.toastDuration);
  }

  closeToast(index: number) {
    this.toasts.splice(index, 1);
  }

  removeToastByStamp(stamp: number) {
    this.toasts = this.toasts.filter((t) => t.timestamp !== stamp);
  }

  async onToastClick(toast: Toast) {
    const { notificationId, link, timestamp, isStatusToast } = toast;
    await this.markNotificationAsRead(notificationId);
    await this.goTo(link);
    if (isStatusToast) return;
    this.removeToastByStamp(timestamp);
  }

  async markNotificationAsRead(notificationId: string) {
    if (!notificationId) return;
    const res = await this.notificationService.markNotificationAsRead(notificationId);
    if (res.success) {
      this.notificationService.readNotificationId.next(notificationId);
    }
  }

  async goTo(link: string) {
    if (link) {
      await this.router.navigate([link]);
    }
  }
}
